"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.ContentTypePrefix = void 0;
/**
 * Prefix of content types
 */
var ContentTypePrefix;
(function (ContentTypePrefix) {
    /**
     * Text type prefix
     */
    ContentTypePrefix["Text"] = "text/";
    /**
     * Image type prefix
     */
    ContentTypePrefix["Image"] = "image/";
})(ContentTypePrefix = exports.ContentTypePrefix || (exports.ContentTypePrefix = {}));
/**
 * Known content types
 */
var ContentType;
(function (ContentType) {
    /**
     * Plain text content type
     */
    ContentType["PlainText"] = "text/plain";
    /**
     * HTML content type
     */
    ContentType["HTML"] = "text/html";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=ContentType.js.map